import { deleteAllNotifications } from "@flixbus-phx/marketplace-common";
import * as React from "react";
import { removeAllRideUpdateErrors } from "../../../../state/rideUpdateErrors/handleRideUpdateErrors";
import useRideFilter, { rideFilterVar } from "../../../../state/useRideFilter/useRideFilter";
import useRideSort, { rideSortVar } from "../../../../state/useRideSort/useRideSort";
import RideListPage from "../rideListPage/RideListPage";

const RideListContainer: React.FC = () => {
  const [rideFilter] = useRideFilter(rideFilterVar);
  const [rideSort] = useRideSort(rideSortVar);
  const [pagesVisible, setPagesVisible] = React.useState(1);

  React.useEffect(() => {
    setPagesVisible(1);

    return () => {
      deleteAllNotifications();
      removeAllRideUpdateErrors();
    };
  }, [rideFilter]);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setPagesVisible((prev) => prev + 1);
        }
      });
    },
    { threshold: 0, rootMargin: "0px 0px 24px 0px" }
  );

  return (
    <>
      {Array.from(Array(pagesVisible)).map((_, i, arr) => {
        return (
          <RideListPage
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            rideFilter={rideFilter}
            rideSort={rideSort}
            page={i}
          >
            {i === arr.length - 1 ? (
              <div
                ref={(node) => {
                  if (node) {
                    observer.observe(node);
                  }
                  return () => {
                    if (node) {
                      observer.unobserve(node);
                    }
                  };
                }}
                style={{ height: "1px" }}
              />
            ) : null}
          </RideListPage>
        );
      })}
    </>
  );
};

export default RideListContainer;
